module.exports = __webpack_public_path__ + "img/talents1.60719c02.jpg";